"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriberForm = void 0;
class SubscriberForm {
    constructor({ id, name, title, description, name_enabled, name_placeholder, email_placeholder, phone_enabled, phone_placeholder, privacy_url, cta_label, click_tracking, submit_click_tracking, owner_id, created_at, updated_at, no_of_subscriptions, } = {
        id: 0,
        name: '',
        title: '',
        description: null,
        name_enabled: false,
        name_placeholder: null,
        email_placeholder: '',
        phone_enabled: false,
        phone_placeholder: null,
        privacy_url: '',
        cta_label: null,
        click_tracking: null,
        submit_click_tracking: null,
        owner_id: 0,
        created_at: null,
        updated_at: null,
        no_of_subscriptions: 0,
    }) {
        this.id = id;
        this.title = title;
        this.name = name;
        this.description = description;
        this.name_enabled = name_enabled;
        this.name_placeholder = name_placeholder;
        this.email_placeholder = email_placeholder;
        this.phone_enabled = phone_enabled;
        this.phone_placeholder = phone_placeholder;
        this.privacy_url = privacy_url;
        this.cta_label = cta_label;
        this.click_tracking = click_tracking;
        this.submit_click_tracking = submit_click_tracking;
        this.owner_id = owner_id;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.no_of_subscriptions = no_of_subscriptions;
    }
}
exports.SubscriberForm = SubscriberForm;
//# sourceMappingURL=form.js.map